import axios from 'axios'
import stroage from '../storage/storage'

//axios.defaults.baseURL = 'http://192.168.224.64:8078'
axios.defaults.baseURL = '//api.onestop-service.com'
axios.defaults.timeout = 5000

axios.interceptors.request.use(
  config => {
    const use = stroage.get('__USD');
    if(use) {
      config.headers['token'] = use.token
    }
    return config
  },
  err => {
    return Promise.reject(err)
  })

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    return Promise.reject(error.data)
  })

export default {
  get(url, params) {
    return new Promise((resolve, reject) => {
      axios.get(url, params)
           .then((response) => {
             if(!response.data) {
               throw new Error();
               return
             }
             if(response.data.resultCode !== '0000') {
               throw new Error(response.data.resultCode);
               return
             }
             resolve(response.data)
           }, error => {
             throw new Error(error)
           })
           .catch((error) => {
             reject(error)
           })
    })
  },
  post(url, params) {
    return new Promise((resolve, reject) => {
      axios.post(url, params)
           .then((response) => {
             if(!response.data) {
               throw new Error();
             }
             if(response.data.resultCode !== '0000') {
               reject(response.data);
             }
             if(response.data.resultCode === '8888') {
               stroage.clear();
               window.location.href = '/#/login';
             }
             resolve(response.data)
           }, error => {
             throw new Error(error)
           })
           .catch((error) => {
             reject(error)
           })
    })
  },
  url() {
    return axios.defaults.baseURL
  }
}



// WEBPACK FOOTER //
// ./src/api/http.js